import { MessageBus } from '@podium/browser';
import type { SearchKey } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';
import { useAppConfig } from '../AppConfig';
import type { SearchParams } from '../state/AppStateTypes';
import { useSearchParams } from './SearchParamsStore';

const SEARCH_CHANNEL = 'search';
const FILTERS_TOPIC = 'filters';

const messageBus = new MessageBus();

type SearchFilterPayload = {
    searchKey: SearchKey;
    searchParams: SearchParams;
};

export function useSearchFilterMessage() {
    const { searchKey } = useAppConfig();
    const { searchParams } = useSearchParams();

    const isInitialRender = React.useRef(true);

    React.useEffect(
        function publishUpdates() {
            if (isInitialRender.current) {
                isInitialRender.current = false;
                return;
            }
            const payload: SearchFilterPayload = {
                searchKey,
                searchParams,
            };
            messageBus.publish(SEARCH_CHANNEL, FILTERS_TOPIC, payload);
        },
        [isInitialRender, searchKey, searchParams],
    );
}
